import { useDispatch, useSelector } from "react-redux";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { useEffect } from "react";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  HOLIDAYS_ACCESS,
  ROUTE_TIMESHEETS_REPORTS,
} from "../../SharedModule/utils/constants";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";

export const ChangesToHolidaysReportPage = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  // to help telerik reports to get correct local timezone
  const today = new Date();
  const startDate = new Date(
    Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      1,
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    )
  );
  const importDate = new Date(
    Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    )
  );
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
    StartDate: startDate,
    EndDate: importDate,
  };

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - Changes to Holidays Report";
    dispatch(setActiveTab(ROUTE_TIMESHEETS_REPORTS));
  }, []);

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, HOLIDAYS_ACCESS, userRolesList) && (
          <ForbiddenPage />
        )}
      {rolesLoaded &&
        verifyModuleAccess(true, HOLIDAYS_ACCESS, userRolesList) && (
          <TelerikReport
            title="Changes to Holidays Report"
            reportName="ChangesToHolidays.trdp"
            parameters={parameters}
            parametersAreaVisible={true}
            backButtonText="Back to Time Reports"
            backButtonRoute={ROUTE_TIMESHEETS_REPORTS}
          />
        )}
    </>
  );
};
